import { Link } from "react-router-dom";
import { ApplyNow, AtThisTime, JoinTalentNetwork, KeyJobDetailsContent, KeyJobDetailsTitle } from "../../../../constants";
import { KeyJobDetailsData } from "../../../../data/Job";
import { routes } from "../../../../routers/routes";
import { dynamicSvg, Image } from "../../../../utils";

const KeyJobDetails = () => {
  return (
    <div>
      <h6>{KeyJobDetailsTitle}</h6>
      <ul className="key-info">
        {KeyJobDetailsData.map((item, index) => (
          <li key={index}>
            <div className="key-icon">
              <Image src={dynamicSvg(`job/job-detail/${item.image}.svg`)} alt="jd-11" />
            </div>
            <span>{item.title}:</span>
            {item.text}
          </li>
        ))}
      </ul>
      <div className="apply-btn">
        <Link to={routes.Pages.Other.ContactUs1} className="btn-solid">
          {ApplyNow}
        </Link>
      </div>
      <h6 className="mb-2">{AtThisTime}</h6>
      <p>{KeyJobDetailsContent}</p>
      <Link to={routes.Pages.Other.ContactUs1} className="arrow-btn">
        {JoinTalentNetwork} <i className="ri-arrow-right-up-line" />
      </Link>
    </div>
  );
};

export default KeyJobDetails;
